// extracted by mini-css-extract-plugin
export default {"catValueCol":"AssetValue_catValueCol__Z08ee","catValue":"AssetValue_catValue__eFMYw","catPercent":"AssetValue_catPercent__SI86U","catPercentRed":"AssetValue_catPercentRed__yvXiT"};